import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { isArrayValidAndNotEmpty, isValidFunction } from '../constants/CommonUtil';
import { getStringFromObject } from '../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../constants/nullCheckUtils';
import ReactSelectMaterialTable from './ReactSelectMaterialTable/ReactSelectMaterialTable';

const styles = () => ({
    input: {
        padding: '0',
    },
});

class FormikReactSelectMaterialTable extends React.Component {
    onChange = (option) => {
        const { field: { name }, form } = this.props;
        const setFieldValue = getStringFromObject('setFieldValue', form);
        const validateOnChange = getStringFromObject('validateOnChange', form, false);

        if (isValidFunction(setFieldValue)) {
            if (Array.isArray(option) && option.length === 0) {
                setFieldValue(name, null, validateOnChange);
            } else {
                setFieldValue(name, option, validateOnChange);
            }
        }

        this.onSelectHandler(option);
    };

    onSelectHandler = (value) => {
        const {
            field: { name },
            form,
            onSelectHandlers,
            actionHandlers,
            actionParams,
        } = this.props;

        if (
            isArrayValidAndNotEmpty(onSelectHandlers) &&
            name &&
            isObjectValidAndNotEmpty(actionHandlers) &&
            isObjectValidAndNotEmpty(form)
        ) {
            onSelectHandlers.forEach((action) => {
                const handler = actionHandlers[action];
                if (isValidFunction(handler)) {
                    handler(value, name, form, actionParams);
                }
            });
        }
    };

    onBlur = () => {
        const { field: { name }, form } = this.props;
        const setFieldTouched = getStringFromObject('setFieldTouched', form);
        const validateOnBlur = getStringFromObject('validateOnBlur', form, false);
        if (isValidFunction(setFieldTouched)) {
            setFieldTouched(name, true, validateOnBlur);
        }
    };

    render() {
        const {
            field: { name, value },
            form,
            options,
            dataSourceApi,
            dataSourceConfig,
            label,
            editable,
            multiple,
            noLabel,
            autocomplete,
            creatable,
            isDisabled,
            placeholder,
            defaultOptions,
            autoFocus,
            tableColumns,
            fixedOptionSet,
            fixedOptionsSetApi,
            fixedOptionSetFilter,
            apiFieldsToMerge,
            cacheOptions,
            textColor,
            autocompleteSelectStyle,
            rootStyle,
        } = this.props;

        const touched = getStringFromObject(`touched.${name}`, form, false);
        const error = getStringFromObject(`errors.${name}`, form, '');

        return (
            <ReactSelectMaterialTable
                value={value}
                label={label}
                placeholder={placeholder}
                dataSourceApi={dataSourceApi}
                dataSourceConfig={dataSourceConfig}
                options={options}
                editable={editable}
                noLabel={noLabel}
                autocomplete={autocomplete}
                multiple={multiple}
                cacheOptions={cacheOptions}
                creatable={creatable}
                onChange={this.onChange}
                onBlur={this.onBlur}
                fixedOptionSet={fixedOptionSet}
                fixedOptionsSetApi={fixedOptionsSetApi}
                fixedOptionSetFilter={fixedOptionSetFilter}
                errorText={touched && error ? error : ''}
                isDisabled={isDisabled}
                textColor={textColor}
                defaultOptions={defaultOptions}
                autoFocus={autoFocus}
                tableColumns={tableColumns}
                apiFieldsToMerge={apiFieldsToMerge}
                autocompleteSelectStyle={autocompleteSelectStyle}
                rootStyle={rootStyle}
                textFieldProps={{
                    label: noLabel ? '' : label,
                    InputLabelProps: { shrink: true },
                }}
            />
        );
    }
}

FormikReactSelectMaterialTable.propTypes = {
    field: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    onSelectHandlers: PropTypes.array,
    actionHandlers: PropTypes.object,
    actionParams: PropTypes.object,
    dataSourceConfig: PropTypes.object.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    options: PropTypes.array,
    fixedOptionSet: PropTypes.array,
    dataSourceApi: PropTypes.string,
    editable: PropTypes.bool,
    noLabel: PropTypes.bool,
    multiple: PropTypes.bool,
    autocomplete: PropTypes.bool,
    creatable: PropTypes.bool,
    isDisabled: PropTypes.bool,
    cacheOptions: PropTypes.bool,
    defaultOptions: PropTypes.bool,
    autoFocus: PropTypes.bool,
    textColor: PropTypes.string,
    fixedOptionsSetApi: PropTypes.string,
    fixedOptionSetFilter: PropTypes.func,
    autocompleteSelectStyle: PropTypes.object,
    rootStyle: PropTypes.object,
    tableColumns: PropTypes.array,
    apiFieldsToMerge: PropTypes.array,
};

FormikReactSelectMaterialTable.defaultProps = {
    onSelectHandlers: [],
    actionHandlers: {},
    actionParams: {},
    label: 'Search and Select',
    placeholder: 'Search...',
    options: [],
    fixedOptionSet: [],
    dataSourceApi: '',
    editable: true,
    noLabel: false,
    multiple: false,
    autocomplete: false,
    creatable: false,
    isDisabled: false,
    cacheOptions: true,
    defaultOptions: true,
    autoFocus: false,
    textColor: '#000000',
    fixedOptionsSetApi: '',
    fixedOptionSetFilter: () => true,
    autocompleteSelectStyle: {},
    rootStyle: {},
    tableColumns: [],
    apiFieldsToMerge: [],
};

export default withStyles(styles)(FormikReactSelectMaterialTable);
